import 'css-chunksrc/client/scenes/commentRemoval/styles.scss';export default {
  "commentRemoval": "_commentRemoval_qqc1f_1",
  "header": "_header_qqc1f_5",
  "group": "_group_qqc1f_9",
  "subTitle": "_subTitle_qqc1f_13",
  "text": "_text_qqc1f_19",
  "main": "_main_qqc1f_25",
  "buttons": "_buttons_qqc1f_32"
};